function errorNotifiy(errorMessage) {
  if(errorMessage) {
    return alert(errorMessage);
  }

  return alert('알 수 없는 오류로 화면을 불러올 수 없습니다.');
}

export {
  errorNotifiy,
};



// WEBPACK FOOTER //
// ./src/core/error-helper.js